import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

const DashboardLoyaltyTabs = ({ className = '', onNavigate, fullWidth = false }) => {
  const router = useRouter();
  const { userId, businessAccountId } = router.query;

  const dashboardHref = userId
    ? `/?userId=${userId}&businessAccountId=${businessAccountId}`
    : '/';
  const loyaltyHref = userId
    ? `/loyalty-lookup?userId=${userId}&businessAccountId=${businessAccountId}`
    : '/loyalty-lookup';

  const isDashboard = router.pathname === '/';
  const isLoyalty = router.pathname.includes('/loyalty-lookup');

  const baseBtn = `rounded-md sm:rounded-lg text-xs font-semibold transition-all whitespace-nowrap text-center ${
    fullWidth ? 'flex-1 px-3 py-2' : 'px-3 sm:px-4 py-2'
  }`;
  const activeBtn = 'bg-white text-primary-900 shadow-sm';
  const inactiveBtn = 'text-secondary-600 hover:text-black-900 hover:bg-white/50';

  const handleNavigate = (href) => {
    onNavigate?.();
    router.push(href);
  };

  return (
    <div
      className={`flex items-center bg-primary-400 border border-primary-500/20 rounded-lg sm:rounded-xl p-1 sm:p-1.5 gap-0.5 ${
        fullWidth ? 'w-full' : ''
      } ${className}`}
    >
      <button
        type="button"
        onClick={() => handleNavigate(dashboardHref)}
        className={`${baseBtn} ${isDashboard ? activeBtn : inactiveBtn}`}
      >
        Dashboard
      </button>
      <button
        type="button"
        onClick={() => handleNavigate(loyaltyHref)}
        className={`${baseBtn} ${isLoyalty ? activeBtn : inactiveBtn}`}
      >
        Loyalty
      </button>
    </div>
  );
};

DashboardLoyaltyTabs.propTypes = {
  className: PropTypes.string,
  onNavigate: PropTypes.func,
  fullWidth: PropTypes.bool,
};

export default DashboardLoyaltyTabs;
